import axios from 'axios';
import { config } from './config';
import { EventBus } from './eventBus';

export const HTTP = axios.create({
  baseURL: config.api_server
});

// Dynamically set Authorization header on each request
HTTP.interceptors.request.use(
  (requestConfig) => {
    const token = localStorage.getItem('jwt');
    if (token) {
      requestConfig.headers.Authorization = `Bearer ${token}`;
    }
    return requestConfig;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const makeRequest = async function (method, endpoint, data = {}, config = {}) {
  try {
    const response = await HTTP.request({
      method,
      url: endpoint,
      ...(method === 'get' ? { params: data } : { data }),
      ...config,
    });

    if (response.status === 200) {
      return response.data;
    }

    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    const errorPayload = {
      status: error.response?.status || 500,
      message: error.response?.data || 'An unexpected error occurred',
    };

    EventBus.$emit('http-error', errorPayload);

    return errorPayload;
  }
};
